var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-buttons-block"},[_c('h1',{staticClass:"ada-focus",attrs:{"role":"alert","aria-live":"assertive","tabindex":"0"}},[_vm._v("Need Help?")]),_vm._v(" "),_c('v-base-nav-page',{attrs:{"links":_vm.links}}),_vm._v(" "),_c('v-base-nav-links',{attrs:{"contact-only":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }